import React, { createContext, useState, useEffect } from 'react';

const LayoutContext = createContext();

export const LayoutProvider = ({ children }) => {
  const [layout, setLayout] = useState(() => {
    // Try to get the layout from localStorage
    const savedLayout = localStorage.getItem('dashboardLayout');
    return savedLayout || 'default';
  });

  // Update localStorage when layout changes
  useEffect(() => {
    localStorage.setItem('dashboardLayout', layout);
  }, [layout]);

  return (
    <LayoutContext.Provider value={{ layout, setLayout }}>
      {children}
    </LayoutContext.Provider>
  );
};

export default LayoutContext;
